import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

/**
 * Hook для управления кнопкой "Назад" в Telegram WebApp
 * 
 * @param {boolean} show - Показывать ли кнопку (по умолчанию true)
 * @param {function} onBack - Кастомный обработчик нажатия (опционально)
 * 
 * Автоматически показывает кнопку "Назад" на всех страницах кроме главной
 * При нажатии использует React Router navigate(-1) для возврата назад
 */
const useTelegramBackButton = (show = true, onBack = null) => {
  const navigate = useNavigate()
  const location = useLocation()
  const tg = window.Telegram?.WebApp

  useEffect(() => {
    // Проверяем, что мы в Telegram WebApp
    if (!tg || !tg.BackButton) {
      return
    }

    // Определяем, показывать ли кнопку
    const isHomePage = location.pathname === '/' || location.pathname === '/onboarding'
    const shouldShow = show && !isHomePage

    // Обработчик нажатия на кнопку "Назад"
    const handleBackClick = () => {
      if (onBack) {
        // Используем кастомный обработчик если передан
        onBack()
      } else {
        // По умолчанию используем React Router навигацию
        navigate(-1)
      }
    }

    if (shouldShow) {
      // Показываем кнопку и устанавливаем обработчик
      tg.BackButton.show()
      tg.BackButton.onClick(handleBackClick)
    } else {
      // Скрываем кнопку
      tg.BackButton.hide()
    }

    // Cleanup: убираем обработчик и скрываем кнопку при размонтировании
    return () => {
      if (tg.BackButton) {
        tg.BackButton.offClick(handleBackClick)
        tg.BackButton.hide()
      }
    }
  }, [tg, show, location.pathname, navigate, onBack])
}

export default useTelegramBackButton
